"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotteryPrizeClaimUpdateInputSchema = exports.APosLotteryPrizeClaimCreateInputSchema = exports.APosLotteryPrizeClaimSchema = exports.APosLotteryClaimStatusSchema = exports.APosLotteryClaimTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const lottery_game_schema_1 = require("./lottery-game.schema");
exports.APosLotteryClaimTypeSchema = zod_1.z.enum(['instant', 'deferred']);
exports.APosLotteryClaimStatusSchema = zod_1.z.enum([
    'pending',
    'paid',
    'rejected',
    'referred_to_office',
]);
exports.APosLotteryPrizeClaimSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    claimId: id_schema_1.EntityIdSchema,
    gameId: id_schema_1.EntityIdSchema,
    gameCategory: lottery_game_schema_1.APosLotteryGameCategorySchema,
    // Scratch-off only
    bookId: zod_1.z.string().optional(),
    ticketNumber: zod_1.z.string().optional(),
    claimAmount: zod_1.z.number().int().min(0).describe('Claim amount in cents'),
    claimType: exports.APosLotteryClaimTypeSchema,
    status: exports.APosLotteryClaimStatusSchema,
    customerName: zod_1.z.string().optional(),
    customerId: zod_1.z.string().optional(),
    verifiedBy: zod_1.z.string().optional(),
    paidAt: zod_1.z.string().optional().describe('ISO datetime string'),
    locationId: id_schema_1.EntityIdSchema,
    posTransactionId: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLotteryPrizeClaimCreateInputSchema = zod_1.z.object({
    gameId: id_schema_1.EntityIdSchema,
    gameCategory: lottery_game_schema_1.APosLotteryGameCategorySchema,
    bookId: zod_1.z.string().optional(),
    ticketNumber: zod_1.z.string().optional(),
    claimAmount: zod_1.z.number().int().min(0),
    claimType: exports.APosLotteryClaimTypeSchema,
    status: exports.APosLotteryClaimStatusSchema,
    customerName: zod_1.z.string().optional(),
    customerId: zod_1.z.string().optional(),
    verifiedBy: zod_1.z.string().optional(),
    paidAt: zod_1.z.string().optional(),
    locationId: id_schema_1.EntityIdSchema,
    posTransactionId: zod_1.z.string().optional(),
});
exports.APosLotteryPrizeClaimUpdateInputSchema = exports.APosLotteryPrizeClaimCreateInputSchema.partial();
//# sourceMappingURL=lottery-prize-claim.schema.js.map